import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestStorage } from "../apiRequests/requestStorage";

export const requestEmailUterum = createAsyncThunk(
  "thunks/requestEmailUterum",
  async (data = { email: "", newsletter: false }, thunkAPI) => {
    const state = thunkAPI.getState();
    const { Uterum, Misc, requests } = state;
    const { apiConfigs } = requests;

    (!data || Object.keys(data).length === 0) &&
      console.error(`Unexpected data in thunks/requestEmailUterum: ${data}`);

    Object.keys(data).some(
      (key) =>
        key !== "email" &&
        key !== "newsletter" &&
        console.error(`Unexpected key in thunks/requestEmailUterum: ${key}`)
    );

    !Misc.Key &&
      console.error(`Misc.Key is missing in thunks/requestEmailUterum`);

    const response = await requestStorage({
      method: "post",
      apiConfigs,
      params: {
        Key: Misc.Key,
      },
      data: {
        uterum: Uterum,
        ...data,
      },
      onSuccess: (apiResponse) => {
        return { data: { Key: apiResponse.data } };
      },
    });

    return response.data;
  },
  conditionRuleset
);
